// eslint-disable-next-line import/no-mutable-exports
let logger = console;

if (typeof window === 'undefined' || process.env.NODE_ENV === 'test') {
  const bunyan = require('bunyan');
  // eslint-disable-next-line clubmed/use-alias
  const config = require('../config');
  logger = bunyan.createLogger(config.get('logger.server') || { name: 'b2c', level: 'warn' });

  if (process.env.NODE_ENV === 'test') {
    logger.level(bunyan.FATAL + 1);
  }
}

export default logger;
